import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import _reduce from 'lodash/reduce';
import _castArray from 'lodash/castArray';
import _isEmpty from 'lodash/isEmpty';
import _get from 'lodash/get';
import lookupReader from 'tbase/readers/lookup';
import getAxiosInstance from 'tbase/utils/api';
import { getDefaultHeader } from './apiService';
import { TYPE_TO_MAPPER as STANDARD_TYPE_MAPPER, DEFAULT_MAPPER } from '../utils/optionMappers/standardFieldMapper';
import { TYPE_TO_MAPPER as CUSTOMER_TYPE_MAPPER } from '../utils/optionMappers/customFieldMappers';
import { ENTITY_MAPPER } from '../utils/optionMappers/entityMappers';
import { EMPTY_ARRAY, EMPTY_OBJECT } from '../app.constants';
var BULK_LOOKUP_URL = 'lookup/ids';
var LOOKUP_SEARCH = 'lookup/search';
var LOOKUP_ALL = 'lookup/all';
export function getKeyByData(key, resolvedEntities) {
  return _reduce(resolvedEntities, function (acc, entity) {
    var _ref = STANDARD_TYPE_MAPPER[key] || CUSTOMER_TYPE_MAPPER[key] || DEFAULT_MAPPER,
        value = _ref.value;

    var mapperFn = ENTITY_MAPPER[key] || ENTITY_MAPPER.DEFAULT;
    return _objectSpread(_objectSpread({}, acc), {}, _defineProperty({}, value(entity), mapperFn(entity)));
  }, EMPTY_OBJECT);
}

function getResourceSearchParams(filters, searchQuery, pageInfo, sort, includeFields) {
  return {
    filters: filters,
    searchText: searchQuery,
    pageInfo: pageInfo,
    sort: sort,
    includeFields: includeFields
  };
}
/**
 * bulk lookup api call
 * @returns {object}
 * {
 *    [RESOURCE_TYPE]: {
 *        ids: [],
 *     },
 * }
 */


export function resolveBulkResource(payload) {
  var axios = getAxiosInstance();
  return axios({
    method: 'POST',
    headers: _objectSpread({}, getDefaultHeader()),
    url: BULK_LOOKUP_URL,
    data: payload
  });
}
export function getLookupParams(lookupRequests) {
  return _reduce(lookupRequests, function (acc, params, key) {
    return _objectSpread(_objectSpread({}, acc), {}, _defineProperty({}, key, {
      ids: params.keys
    }));
  }, {});
}
/**
 * Bulk lookup service
 * @param {object} lookupRequests - object of assetType vs values containing ids to lookup.
 * {
 *    [RESOURCE_TYPE]: { keys: [] }
 * }
 */

export var lookupMultipleResource = function lookupMultipleResource(lookupRequests) {
  var createLookupMapByResourceType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : EMPTY_OBJECT;
  var requestToMake = getLookupParams(lookupRequests);
  return resolveBulkResource(requestToMake).then(function (_ref2) {
    var data = _ref2.data.data;
    return _reduce(data, function (acc, resolvedData, key) {
      var keyByDataResolver = createLookupMapByResourceType[key] || getKeyByData;
      return _objectSpread(_objectSpread({}, acc), {}, _defineProperty({}, key, keyByDataResolver(key, resolvedData, data)));
    }, {});
  });
};
/**
 * resolve resource by assetType and keys
 * @param {string} resourceType - type to lookup for
 * @param {array} keysToResolve - array of ids to lookup for
 */

export var getLookupByKeys = function getLookupByKeys(resourceType, keysToResolve) {
  return lookupMultipleResource(_defineProperty({}, resourceType, {
    keys: _castArray(keysToResolve)
  })).then(function (data) {
    return data[resourceType];
  });
};
export var lookupAll = function lookupAll(resourceTypes) {
  return getAxiosInstance()({
    method: 'POST',
    headers: _objectSpread({}, getDefaultHeader()),
    url: LOOKUP_ALL,
    data: resourceTypes
  }).then(function (_ref3) {
    var data = _ref3.data.data;
    return data;
  });
};
export var lookupSearch = function lookupSearch(resourceType) {
  var _ref4 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : EMPTY_OBJECT,
      _ref4$filters = _ref4.filters,
      filters = _ref4$filters === void 0 ? EMPTY_ARRAY : _ref4$filters,
      sort = _ref4.sort,
      _ref4$searchQuery = _ref4.searchQuery,
      searchQuery = _ref4$searchQuery === void 0 ? '' : _ref4$searchQuery,
      _ref4$searchText = _ref4.searchText,
      searchText = _ref4$searchText === void 0 ? '' : _ref4$searchText,
      includeFields = _ref4.includeFields,
      _ref4$pageInfo = _ref4.pageInfo,
      pageInfo = _ref4$pageInfo === void 0 ? {
    start: 0,
    rows: 20
  } : _ref4$pageInfo;

  return getAxiosInstance()({
    method: 'POST',
    headers: _objectSpread({}, getDefaultHeader()),
    url: LOOKUP_SEARCH,
    data: _defineProperty({}, resourceType, getResourceSearchParams(filters, searchQuery || searchText, pageInfo, sort, includeFields))
  }).then(function (_ref5) {
    var data = _ref5.data.data;

    var resourceTypeData = _get(data, resourceType, EMPTY_OBJECT);

    var entities = lookupReader.entities(resourceTypeData) || EMPTY_ARRAY;
    var count = lookupReader.count(resourceTypeData);
    return {
      resources: entities,
      hasMore: !_isEmpty(entities),
      count: count
    };
  });
};